<template>
  <RadioGroup
    :disabled="isReadOnlyDialog"
    required
    :items="[
      { data: { value: 'Yes', label: $t('wizer.common.yes') } },
      { data: { value: 'No', label: $t('wizer.common.no') } },
    ]"
  >
  </RadioGroup>
</template>

<script>
import RadioGroup from '@wizer/core/components/radio-group/RadioGroup'
import SustainabilityInputMixin from '@/mixins/SustainabilityInputMixin'

export default {
  name: 'RadioInput',
  mixins: [SustainabilityInputMixin],
  components: {
    RadioGroup,
  },
  props: {
    isReadOnlyDialog: Boolean,
  },
}
</script>
